import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  CircularProgress,
} from "@material-ui/core";
import axios from "../../app/axios";

const ClassNotices = () => {
  const [notices, setNotices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotices = async () => {
      try {
        setLoading(true);
        const token = window.localStorage.getItem("x-auth-token");
        const response = await axios.get("/updatenotices", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
        // Format the data: use ses_notice as message and ses_startdate as date
        const formattedNotices = response.data.map((notice) => ({
          message: notice.ses_notice || "",
          date: notice.ses_startdate 
            ? new Date(notice.ses_startdate).toISOString().split("T")[0]
            : "",
            title: notice.ses_updatenoticetitle || "",

        }));
        
        setNotices(formattedNotices);
        setError(null);
      } catch (err) {
        console.error("Error fetching notices:", err);
        setError("Failed to load notices");
        setNotices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNotices();
  }, []);

  return (
    <Card
      elevation={3}
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        marginBottom: 24,
      }}
    >
      <CardHeader title="Class Notices" />
      <CardContent
        style={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: 20 }}>
            <CircularProgress />
          </div>
        ) : error ? (
          <Typography variant="body2" color="error" style={{ padding: 20 }}>
            {error}
          </Typography>
        ) : notices.length === 0 ? (
          <Typography variant="body2" color="textSecondary" style={{ padding: 20 }}>
            No notices available
          </Typography>
        ) : (
          <List style={{ flex: 1 }}>
            {notices.map((notice, index) => (
              <React.Fragment key={index}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={
                      <>
                        <Typography
                          component="span"
                          variant="body2"
                          color="textPrimary"
                           style={{ fontSize: '16px',fontWeight: 'bold' }}
                        >
                          {notice.title}
                        </Typography>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                        <Typography
                          component="span"
                          variant="body2"
                          color="textPrimary"
                          style={{ flex: 1 }}
                        >
                          {notice.message}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="textSecondary"
                          style={{ marginLeft: 16, whiteSpace: 'nowrap' }}
                        >
                          {notice.date}
                        </Typography>
                      </div>
                      </>
                    }
                  />
                </ListItem>
                {index < notices.length - 1 && (
                  <Divider variant="inset" component="li" />
                )}
              </React.Fragment>
            ))}
          </List>
        )}
      </CardContent>
    </Card>
  );
};

export default ClassNotices;
